module.exports = __webpack_public_path__ + "static/img/ent-detail-63.c61f52f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-63.jpg
// module id = BhAe
// module chunks = 51